import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import './styles.css';

class Permission extends Component {

    state = {
        load: false,
        sectors: {},
        documentTypes: {},
        idSectorSelected: null,
        documentsByTypeDocuments: {},
        idDocumentTypes: null,
        documentsChecked: {},
        documentsSectorDocumentType: {},
        successDocuments: false,
    }

    componentDidMount() {
        this.searchSectors();
        this.searchDocumentTypes();
    }

    searchSectors = async () => {
        this.setState({ load: true });
        const response = await api.get(`/sectors?status=1`);
        this.setState({ sectors: response.data.rows, load: false });
    }

    searchDocumentTypes = async () => {
        this.setState({ load: true });
        const response = await api.get(`/document-types?status=1`);
        this.setState({ documentTypes: response.data.rows, load: false });
    }

    selectSector = (e) => {
        this.setState({ idSectorSelected: e.target.value, idDocumentTypes: null });
    }

    clickTypeDocuments = async (e) => {
        await this.setState({ idDocumentTypes: e.target.value });
        this.searchDocumentsDocumentTypes();
    }

    searchDocumentsDocumentTypes = async () => {
        this.setState({ load: true });
        const response = await api.get(`/sectors/${this.state.idSectorSelected}/documents?status=1&DocumentTypeId=${this.state.idDocumentTypes}`);
        this.setState({ documentsSectorDocumentType: response.data.data, load: false });
    }

    searchDocuments = async (e) => {
        this.setState({ load: true, successDocuments: false });
        const response = await api.get(`/documents?DocumentTypeId=${this.state.idDocumentTypes}`);
        this.setState({ documentsByTypeDocuments: response.data.rows, load: false });
    }

    checkDocument = async (e) => {
        let dChk = document.getElementsByName("documents");
        let docs = { documents: [] };
        for (var i = 0; i < dChk.length; i++) {
            if (dChk[i].checked == true) {
                docs.documents.push({ DocumentId: dChk[i].value });
            }
        }
        this.setState({ documentsChecked: docs, successDocuments: false });
    }

    submitCheckDocument = async (e) => {
        if (this.state.documentsChecked.documents && this.state.documentsChecked.documents.length) {
            this.setState({ load: true });
            let response = await api.post(`/sectors/${this.state.idSectorSelected}/documents`, this.state.documentsChecked);

            if (response.data.msg) {
                this.setState({ documentsChecked: {}, successDocuments: true, load: false });
            } else {
                this.setState({ successDocuments: false, load: false });
            }
            this.searchDocumentsDocumentTypes();
        }else{
            this.setState({ successDocuments: false, load: false });
        }
    }

    deleteDocument = async (e) => {
        await api.delete(`/sectors/${this.state.idSectorSelected}/documents/${e.target.id}`);
        this.searchDocumentsDocumentTypes();
    }

    verifyDocumentSelected = (id) => {
        return this.state.documentsSectorDocumentType.filter((item) => (item.id == id)).length;
    }

    verifyDocumentSelectedInfo = (id) => {
        return this.state.documentsSectorDocumentType.filter((item) => (item.id == id));
    }

    verifyDocumentSelectedApproval = (id) => {

        if (this.state.documentsSectorDocumentType.length) {
            let data = this.state.documentsSectorDocumentType.filter((item) => (item.id == id));
            console.log( data[0].DocumentToSectors.approve);
            return (data.length) ? data[0].DocumentToSectors.approve : false;
        } else {
            return false;
        }

    }

    setAprovePermission = async (e) => {
        let sector = this.state.idSectorSelected;

        this.setState({ load: true });

        let curdDoc = this.verifyDocumentSelectedInfo(e.target.id);
        let status = curdDoc[0].DocumentToSectors.approve;
        let docs = { approve:!status, documents: [{ DocumentId:e.target.id}] };
        let response = await api.post(`/sectors/${this.state.idSectorSelected}/documents-perm`, docs);
     
        if (response.data.msg) {
            this.setState({ documentsChecked: {}, successDocuments: true, load: false });
        } else {
            this.setState({ successDocuments: false, load: false });
        }
        this.searchDocumentsDocumentTypes();


    }



    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Permissões
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <h5>Selecione a área para configurar o permissionamento</h5>
                        <select className="custom-select col-md-12" onChange={this.selectSector}>
                            <option value="">Todas</option>
                            {
                                (this.state.sectors.length) ?
                                    this.state.sectors.map((item, index) => {
                                        return (
                                            <option key={index} value={item.id}>{item.name}</option>
                                        )
                                    })
                                    : null
                            }
                        </select>
                        <br /><br />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h5>Tipos de Documento</h5>
                        <div className="row">
                            {
                                (this.state.documentTypes.length) ?
                                    this.state.documentTypes.map((item) => {
                                        return (
                                            <div key={item.id} className="col-md-3">
                                                <button onClick={this.clickTypeDocuments} disabled={(!this.state.idSectorSelected)} className="col-md-12 btn waves-effect waves-light btn-rounded btn-primary" key={item.id} value={item.id}>
                                                    {item.description}
                                                </button>
                                            </div>
                                        )
                                    })
                                    : null
                            }
                        </div>
                    </div>
                    {(this.state.idDocumentTypes) ?
                        <div className="col-md-12">
                            <br />
                            <div className="card">
                                <h5 className="p-10 text-themecolor">Lista de documentos</h5>
                                <table className="table table-border">
                                    
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            {/* <th>Visualização</th> */}
                                            <th>Aprovar</th>
                                            <th>Excluir</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody>

                                        {
                                            (this.state.documentsSectorDocumentType.length) ?
                                                this.state.documentsSectorDocumentType.map((item) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>{item.description}</td>
                                                            {/* <td className="td-button">
                                                                <button type="button green" className="btn btn-sm btn-info">
                                                                    <i className="fa fa-2x fa-check-circle"></i>
                                                                </button>
                                                            </td> */}
                                                            <td className="td-button">
                                                                <button type="button green" onClick={this.setAprovePermission} title="Adicionar permissão para aprovação do documento" id={item.id} className={(this.verifyDocumentSelectedApproval(item.id)) ? "btn btn-sm btn-info" : "btn btn-sm btn-warning"  }>
                                                                    <i className={(this.verifyDocumentSelectedApproval(item.id)) ? "fa fa-2x fa-check-circle" : "fa fa-2x fa-times-circle"  }   id={item.id}></i>
                                                                </button>
                                                            </td>
                                                            <td className="td-button" id={item.id} onClick={this.deleteDocument}>
                                                                <button type="button" className="btn btn-sm btn-danger" id={item.id}><i className="fa fa-2x fa-times" id={item.id}></i> </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : <tr><td><div className="text-center p-20">Nenhum documento adicionado</div></td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <button onClick={this.searchDocuments} className="col-md-4 btn waves-effect waves-light btn-rounded btn-success" data-toggle="modal" data-target=".modal-documents">
                                Adicionar Documentos
                            </button>
                        </div>
                        : null}
                </div>

                <div className="modal fade modal-documents" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">Documentos
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {(this.state.documentsByTypeDocuments.length) ?
                                        this.state.documentsByTypeDocuments.map((item) => {
                                            return (
                                                <div key={item.id} className="col-md-12 p-10">
                                                    {(!this.verifyDocumentSelected(item.id)) ?
                                                        <input type="checkbox" name="documents" value={item.id} id={'document_' + item.id} onClick={this.checkDocument} />
                                                        : null}
                                                    <label className={(this.verifyDocumentSelected(item.id)) ? 'text-success' : null} htmlFor={'document_' + item.id}> {item.description} </label>
                                                </div>
                                            )
                                        })
                                        : <div className="text-center p-20">Nenhum documento para adicionar</div>
                                    }
                                </div>

                                {
                                    (this.state.successDocuments) ?
                                        <div className="alert alert-success">Documento(s) inserido(s) com sucesso!</div>
                                        : null
                                }

                            </div>
                            <div className="modal-footer">
                                <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.submitCheckDocument}>
                                    Salvar
                                </button>
                                <button type="button" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default Permission;